import { render, staticRenderFns } from "./announcements-add.vue?vue&type=template&id=23b16443&"
import script from "./announcements-add.vue?vue&type=script&lang=js&"
export * from "./announcements-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports